module.exports = __webpack_public_path__ + "static/media/splash2_2x.b7b53f7f.jpg";